import React from 'react';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import { Modal } from 'react-bootstrap';
import './ShareCalculationModal.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { objectToSearchParams } from '../../../utils/toSearchParams';
import apiCaller from '../../../utils/ApiClient';

interface Props {
  show: boolean;
  setHide: any;
  basket: any;
  uiActions: any;
  loading: any;
}

const ShareCalculationModal = ({ show, setHide, basket, uiActions, loading }: Props) => {
  const [buttonHover, setButtonHover] = React.useState(0);

  const exportExcel = async () => {
    const params = {
      basket: basket.id,
      basketreference: basket.reference,
      format: 'agencyxls',
    };
    const parsedParams = objectToSearchParams(params, true).toString();
    exportFunction('export.xlsx', parsedParams, 'excel');
  };
  const [buttonLoading, setButtonLoading] = React.useState({
    excel: false,
    csv: false,
    pdf: false,
  });
  const exportFunction = async (filename: string, params: string, buttonKey: string) => {
    try {
      uiActions.setLoading('button', true);
      setButtonLoading((prevState) => ({ ...prevState, [buttonKey]: true }));
      await apiCaller('GET', `basketcontent?${params}`).then((resData) => {
        const downloadUrl = window.URL.createObjectURL(resData);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
      setButtonLoading((prevState) => ({ ...prevState, [buttonKey]: false }));
      uiActions.setLoading('button', false);
    } catch (e) {
      console.error(e, 'error in exportXLM');
      setButtonLoading((prevState) => ({ ...prevState, [buttonKey]: false }));
      uiActions.setLoading('button', false);
    }
  };

  const exportCSV = async () => {
    const params = {
      basket: basket.id,
      basketreference: basket.reference,
      format: 'agencycsv',
    };
    const parsedParams = objectToSearchParams(params, true).toString();
    exportFunction('export.csv', parsedParams, 'csv');
  };

  const exportXLM = async () => {
    const params = {
      basket: basket.id,
      basketreference: basket.reference,
      format: 'agencypdf',
    };
    const parsedParams = objectToSearchParams(params, true).toString();
    exportFunction('export.pdf', parsedParams, 'pdf');
  };
  return (
    <Modal
      show={show}
      onHide={setHide}
      backdrop='static'
      size='lg'
      keyboard={false}
      className='share-calculation-modal'
      centered
      backdropClassName='share-calculation-backdrop'
    >
      <Modal.Header closeButton className='border-bottom'>
        <Modal.Title>
          <h2>
            <FormattedMessage id='ec.general.shareCalculation' defaultMessage='Kalkulation downloaden' />
          </h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* <div className="d-flex flex-column gap-1">
                        <span className="share-calculation-text">
                            <FormattedMessage
                                id="ec.general.copyCalculationLink"
                                defaultMessage="Copy calculation link:"
                            />
                        </span>
                        <div className="d-flex flex-row share-calculation-width">
                            <Input
                                type="copy"
                                value="https://ecalculator.ecom.apgsga.ch/98tyu2938"
                            />
                        </div>
                    </div> */}
          <div className='share-calculation-buttons'>
            {/* <span className="share-calculation-text">
                            <FormattedMessage
                                id="ec.general.orExport"
                                defaultMessage="or export:"
                            />
                        </span> */}
            <div className='d-flex gap-1'>
              <div
                className='share-calculation-button-parent'
                onMouseEnter={() => setButtonHover(1)}
                onMouseLeave={() => setButtonHover(0)}
              >
                <Button
                  buttonType={EButtonType.InvertedPillMedium}
                  onClick={exportExcel}
                  className='share-calculation-button'
                  isDisabled={basket.id === null || buttonLoading.excel}
                  isLoading={loading.button && buttonLoading.excel}
                >
                  <FormattedMessage id='ec.general.xlsx' defaultMessage='XLSX' />
                  {buttonHover === 1 ? <KitIcons.WhiteExportIcon /> : <KitIcons.ExportIcon />}
                </Button>
              </div>
              <div
                className='share-calculation-button-parent'
                onMouseEnter={() => setButtonHover(2)}
                onMouseLeave={() => setButtonHover(0)}
              >
                <Button
                  buttonType={EButtonType.InvertedPillMedium}
                  onClick={exportCSV}
                  className='share-calculation-button'
                  isDisabled={basket.id === null || buttonLoading.csv}
                  isLoading={loading.button && buttonLoading.csv}
                >
                  <FormattedMessage id='ec.general.csv' defaultMessage='CSV' />
                  {buttonHover === 2 ? <KitIcons.WhiteExportIcon /> : <KitIcons.ExportIcon />}
                </Button>
              </div>
              <div
                className='share-calculation-button-parent'
                onMouseEnter={() => setButtonHover(3)}
                onMouseLeave={() => setButtonHover(0)}
              >
                <Button
                  buttonType={EButtonType.InvertedPillMedium}
                  onClick={exportXLM}
                  className='share-calculation-button'
                  isDisabled={basket.id === null || buttonLoading.pdf}
                  isLoading={loading.button && buttonLoading.pdf}
                >
                  <FormattedMessage id='ec.general.pdf' defaultMessage='PDF (Factsheet)' />
                  {buttonHover === 3 ? <KitIcons.WhiteExportIcon /> : <KitIcons.ExportIcon />}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='top-border'>
        <div className='d-flex flex-row gap-2'>
          <Button
            buttonType={EButtonType.InvertedPillLarge}
            onClick={() => {
              setHide();
            }}
          >
            <FormattedMessage id='ec.general.close' defaultMessage='Schliessen' />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareCalculationModal;
